<template>
  <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                               :latest-image-id="latestImageId"
                               :is-searchable="isSearchable"
                               :machine-id="machineId"
                               :section-title-list="sectionTitleList"
                               :has-top-border-anchor-link="false"
                               :has-title-anchor-link="false"
                               :has-border-anchor-link="false"
                               :has-movie-title="false"
                               youtube-url="https://youtu.be/aE7w8r7-_4k "
  >

    <template v-slot:feature-summary>
      <img :src="buildImgUrl('img_feature_summary.png')" alt="ルートミー２の基本情報">
    </template>
    <template v-slot:content-1>
      <div class="cont-01">
        <img class="img-01" :src="buildImgUrl('img_contents01_01.png')"
             alt="Point1 きゅるっとまるくなった Point2 ほわ白肌とさらツヤ髪おめめ ルートミー2の+2.5次元盛れ">
        <img class="img-02" :src="buildImgUrl('img_contents01_02.png')"
             alt="ルートミーのしっかりかわいい盛れ感はそのままに、超高画質にパワーアップした写りでも一一っと盛れる！さらに!白目の大きさまで調整できるきゃわ目レタッチで自分好みの理想のおめめが完成♥">
      </div>
    </template>
    <template v-slot:content-2>
      <div class="cont-02">
        <img class="img-01" :src="buildImgUrl('img_contents02_01.png')"
             alt="4つのテイストに合った一発らくがきが超可愛い！スタンプやペンと組み合わせてもーーっとデコが楽しめちゃう♥">
        <div class="img-02-wrapper">
          <img class="img-02" :src="buildImgUrl('img_contents02_02.png')"
               alt="背景カラーや余白も調整できるから自分好みにアレンジできるよ♥">
          <img class="gif-01" :src="buildImgUrl('arrange01.gif')" alt="gif">
          <img class="gif-02" :src="buildImgUrl('arrange02.gif')" alt="gif">
        </div>
      </div>
    </template>
    <template v-slot:content-3>
      <div class="cont-03">
        <img class="img-01" :src="buildImgUrl('img_contents03.png')"
             alt="ペンで描いたらくがきを移動やコピーができるから超簡単に思い通りのらくがきにできて仕上がりUP♥">
      </div>
    </template>
    <template v-slot:content-4>
      <div class="cont-04">
        <img class="img-01" :src="buildImgUrl('img_contents04.png')"
             alt="らくがきに合う派手可愛いシールデザインが盛りだくさん！どの組み合わせにしても、超可愛い特別な1枚に仕上がる♥">
      </div>
    </template>
    <template v-slot:content-5>
      <div class="cont-05" data-jest="tamagochi-collaboration">
        <img class="img-01" :src="buildImgUrl('img_contents05.png')"
             alt="「たまごっち」の世界観を楽しめるコンテンツを搭載！初期の懐かしいデザインのフレームやシールが可愛すぎる♥">
      </div>
    </template>
  </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "MachineRootme2",
  components: {LayoutMachineIntroduction},
  props: {
    /**
     * Headerコンポーネント用
     * 未保存プリ数
     */
    unsavedPuriCount: {
      type: String,
      required: true
    },
    /**
     * Headerコンポーネント用
     * 最新プリID
     */
    latestImageId: {
      type: String,
      required: true
    },
    /**
     * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
     * toolboxから取得
     * 「遊べるお店を探す」表示判定
     */
    isSearchable: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      accountStatus: 'AccountStoreV2/accountStatus',
    }),
    machineId() {
      return 155;
    },
    sectionTitleList() {
      const titleList = [
        '01 可愛さを突き詰めた +2.5次元盛れ',
        '02 デコが派手可愛い♡ きゃわデコらくがき',
        '03 らくがきのお役立ち機能! らくがき編集ツール',
        '04 きゃわデコらくがきにピッタリ! きゃわ×2シール',
      ];
      if (this.isTmagochiCollaborationInTime) {
        titleList.push('05 90年代がリバイバル♡ たまごっちコラボ')
      }
      return titleList
    },
    /**
     * たまごっちのコラボキャンペーンの期間
     */
    isTmagochiCollaborationInTime() {
      return this.accountStatus.timeTripDate.isInTime("2024-05-22T11:00:00", "2024-08-31T23:59:59");
    },
  },
  mounted() {
    /**
     * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
     * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
     */
    this.getAccountStatus()
  },
  methods: {
    ...mapActions({
      getAccountStatus: 'AccountStoreV2/getAccountStatus'
    }),
    /**
     * 画像のURLを組み立てる
     * @param {string} imgName 画像名
     */
    buildImgUrl(imgName) {
      return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
    },
    /**
     * cssのurl関数に動的な文字列を与えようとすると、上手くcssの関数が呼び出せなかったので、
     * url関数の呼び出し部分の含めた文字列をv-bindで組み立てからstyleで使えるようにしている
     */
    buildStyleImgUrl(imageName) {
      const imgUrl = this.buildImgUrl(imageName)
      return `url(${imgUrl})`;
    },
    /**
     * 「遊べるお店はこちら」ボタンをコラボレーションあり/なしで切り替えたかったが、
     * テンプレートを改変する必要があり、全体の影響も考えてjsで計算し、cssに入力するようにした
     * @return {string} 「遊べるお店はこちら」ボタンのtopからの相対位置（％）
     */
    calcBtnShopListPosition() {
      const deviceWidth = 750;
      const base = this.isTmagochiCollaborationInTime ? 365 : 385;
      const resultPercentage = (base / deviceWidth) * 100;
      return resultPercentage + "%";
    },
  }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
  .c-machine-introduction {
    &-top {
      .btn-shop-list {
        position: absolute;
        top: v-bind("calcBtnShopListPosition()");
        left: 0;
        width: 100%;

        &-link {
          width: math.percentage(math.div(530px, $deviceWidth));
        }
      }

      .list-anchor-link-feature-summary {
        background-image: v-bind("buildStyleImgUrl('link_bk.png')");
        background-repeat: no-repeat;
        background-size: 100%;
      }

      .list-anchor-link {
        padding: (variables.$grid-consistent) 0 (variables.$grid-consistent) 0;

        .img-link {
          width: math.percentage(math.div(594px, $deviceWidth));
        }

        .img-line {
          width: math.percentage(math.div(594px, $deviceWidth));
          display: block;
          margin: auto;
        }
      }

      .feature-summary {
        width: math.percentage(math.div(594px, $deviceWidth));
        padding: 0 0 (variables.$grid-base) 0;
        margin: auto;
      }
    }

    &-contents {
      .accordion-inner {
        .img-01, .img-02, .img-03, .img-04, .img-05, .img-06, .img-07, {
          display: block;
        }

        &.cont-2 {
          .img-02-wrapper {
            position: relative;

            .gif-01 {
              position: absolute;
              top: 20%;
              right: 13%;
              width: math.percentage(math.div(370px, $deviceWidth));
              box-shadow: 0 0 10px 2px rgb(0, 0, 0, 0.2);
            }

            .gif-02 {
              position: absolute;
              bottom: 5%;
              left: 13%;
              width: math.percentage(math.div(370px, $deviceWidth));
              box-shadow: 0 0 10px 2px rgb(0, 0, 0, 0.2);
            }
          }
        }
      }
    }

    &-movie {
      padding: 35% 0 10%;
      background-image: v-bind("buildStyleImgUrl('movie_back.png')");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      &-thumb {
        width: math.percentage(math.div(650px, $deviceWidth));
        margin: 0 auto;
      }

      &-btn-studio {
        width: math.percentage(math.div(420px, $deviceWidth));
        margin: 13% auto 0;
      }
    }
  }
}

</style>
